import React from 'react';
import * as PropTypes from 'prop-types';
import { RelatedVideoItem, RelatedVideoItemPlaceholder } from './related-video-item';
import { LoadingSpinner } from 'components/loading-spinner';
import { useTranslation } from 'react-i18next';

export const RelatedVideoList = ({ videos, loading, linkPrefix, getNextVideos }) => {
  const onScroll = (obj) => {
    if ((obj.target.scrollTop * 100) / (obj.target.scrollHeight - obj.target.clientHeight) > 80) {
      getNextVideos();
    }
  };
  const { t } = useTranslation();

  return (
    <div className="ct-related-video-list" data-e2e="related-video-list">
      <h3 className="ct-related-video-list__title">{t('related_videos')}</h3>
      {loading && videos.length === 0 && (
        <div className="ct-related-video-list__placeholders">
          <RelatedVideoItemPlaceholder />
        </div>
      )}
      {videos.length > 0 && (
        <div className="ct-related-video-list__videos" data-e2e="list-items" onScroll={onScroll}>
          {videos.map((video) => (
            <RelatedVideoItem key={video.id} video={video} url={`${linkPrefix}${video.id}`} />
          ))}
          {loading && <LoadingSpinner />}
        </div>
      )}
      {!loading && videos.length === 0 && (
        <div className="ct-related-video-list__no-videos" data-e2e="no-videos-message">
          {t('we_couldnt_find_any_related_videos')}
        </div>
      )}
    </div>
  );
};

RelatedVideoList.propTypes = {
  loading: PropTypes.bool.isRequired,
  videos: PropTypes.array.isRequired,
  getNextVideos: PropTypes.func.isRequired,
  linkPrefix: PropTypes.string,
  className: PropTypes.string,
};
